//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import activateLanguageFilter from '~/mixins/ResourceFilterFunctions/language.js';
import deactivateFilter from '~/mixins/ResourceFilterFunctions/deactivate-filter.js';
export default {
	mixins: [activateLanguageFilter, deactivateFilter],
	computed: {
		...mapState({
			filterDropdown: ({ dropdownStore: {filterDropdown} }) => filterDropdown,
			filter: ({ filtersStore: { filter } }) => filter,
			queries: ({ resourcesStore: { queries } }) => queries,
		}),
	},
}
